var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7311_9610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00012 6H5.00012V8H7.00012V6Z",
    fill: "curerntColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 6H9.00012V8H11.0001V6Z",
    fill: "curerntColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00012 0C9.65698 0 11.0001 1.34315 11.0001 3H14.0001L14.3803 12.8847C14.4457 14.5855 13.0846 16 11.3825 16H4.61772C2.91565 16 1.55452 14.5855 1.61994 12.8847L2.00012 3H5.00012C5.00012 1.34315 6.34327 0 8.00012 0ZM7.00012 3H9.00012C9.00012 2.44772 8.55241 2 8.00012 2C7.44784 2 7.00012 2.44772 7.00012 3ZM3.92468 5L3.61846 12.9616C3.59666 13.5285 4.05036 14 4.61772 14H11.3825C11.9499 14 12.4036 13.5285 12.3818 12.9616L12.0756 5H3.92468Z",
    fill: "curerntColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7311_9610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "curerntColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductOutline);
export default __webpack_public_path__ + "static/media/productOutline.91ce189adabdb4a4d0f76b960b8a9e89.svg";
export { ForwardRef as ReactComponent };